import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectHasInternet = createSelector(selectJsonQuery, jsonQuery => getTermValue('internet')(jsonQuery));
